/**
 * Languages planned but not built yet (PRD 3, 11.5, D-44, D-49). They show in Settings as disabled
 * "Coming soon" entries so people can see what is on the way. Nothing here is selectable or saved.
 */

export interface Upcoming {
  id: string;
  /** The language named in itself, so people can find theirs. */
  native: string;
  /** BCP 47 tag for the native name. */
  lang: string;
  dir?: 'rtl';
}

/** App languages planned: Gujarati and Hindi screens (v1.1), Arabic with a right-to-left layout (K6, D-34). */
export const UPCOMING_APP_LANGUAGES: readonly Upcoming[] = [
  { id: 'gu', native: 'ગુજરાતી', lang: 'gu' },
  { id: 'hi', native: 'हिन्दी', lang: 'hi' },
  { id: 'ar', native: 'العربية', lang: 'ar', dir: 'rtl' },
];

/** Relationship-word sets planned, in the order of D-44, with French from the v1.1 list. */
export const UPCOMING_WORD_SETS: readonly Upcoming[] = [
  { id: 'pt', native: 'Português (Brasil)', lang: 'pt-BR' },
  { id: 'ur', native: 'اردو', lang: 'ur', dir: 'rtl' },
  { id: 'bn', native: 'বাংলা', lang: 'bn' },
  { id: 'zh', native: '中文（普通话）', lang: 'zh' },
  { id: 'pa-Arab', native: 'پنجابی', lang: 'pa-Arab', dir: 'rtl' },
  { id: 'ta', native: 'தமிழ்', lang: 'ta' },
  { id: 'te', native: 'తెలుగు', lang: 'te' },
  { id: 'kn', native: 'ಕನ್ನಡ', lang: 'kn' },
  { id: 'ml', native: 'മലയാളം', lang: 'ml' },
  { id: 'mr', native: 'मराठी', lang: 'mr' },
  { id: 'tr', native: 'Türkçe', lang: 'tr' },
  { id: 'fa', native: 'فارسی', lang: 'fa', dir: 'rtl' },
  { id: 'ko', native: '한국어', lang: 'ko' },
  { id: 'vi', native: 'Tiếng Việt', lang: 'vi' },
  { id: 'id', native: 'Bahasa Indonesia / Melayu', lang: 'id' },
  { id: 'fil', native: 'Filipino / Tagalog', lang: 'fil' },
  { id: 'ru', native: 'Русский', lang: 'ru' },
  { id: 'fr', native: 'Français', lang: 'fr' },
  { id: 'ja', native: '日本語', lang: 'ja' },
  { id: 'de', native: 'Deutsch', lang: 'de' },
  { id: 'it', native: 'Italiano', lang: 'it' },
  { id: 'sw', native: 'Kiswahili', lang: 'sw' },
  { id: 'ha', native: 'Hausa', lang: 'ha' },
  { id: 'yo', native: 'Yorùbá', lang: 'yo' },
  { id: 'am', native: 'አማርኛ', lang: 'am' },
];

/** Every id that has a screen-language name in i18n (`settings.upcoming`). */
export type UpcomingId =
  | 'gu' | 'hi' | 'ar' | 'pt' | 'ur' | 'bn' | 'zh' | 'pa-Arab' | 'ta' | 'te' | 'kn' | 'ml' | 'mr' | 'tr' | 'fa'
  | 'ko' | 'vi' | 'id' | 'fil' | 'ru' | 'fr' | 'ja' | 'de' | 'it' | 'sw' | 'ha' | 'yo' | 'am';
